import { Navigate, Outlet } from "react-router-dom";
import { UserRoles } from "@enums/UserRoles";
import { selectAuth } from "@slices/authSlice";
import { useAppSelector } from "@store/hooks";
import { getFromStorage } from "@utilities/storageService";
import { pageRoutes } from "@constants/pageRoutes";

const RequireAuth = ({
    nonLoggedInPages,
    loggedInPages,
    allowedRoles,
}: {
    nonLoggedInPages?: boolean;
    loggedInPages?: boolean;
    allowedRoles?: UserRoles[];
}) => {
    const auth = useAppSelector(selectAuth);
    const nextUrlForFirstTimeLogin = getFromStorage("firstTimeSignupRedirectBackUrl");
    const isServer = typeof window === 'undefined';
    if (nonLoggedInPages) {
        
        if (auth.isLoggedIn) {
            let navigateTo = pageRoutes.DASHBOARD_USER;
            if (auth.userInfo?.role === UserRoles.ADMIN) {
                navigateTo = pageRoutes.DASHBOARD_ADMIN;
            }
            return !isServer ?<Navigate to={nextUrlForFirstTimeLogin ?? navigateTo} />:null;
        } else {
            return <Outlet />;
        }
    } else if (loggedInPages) {
        if (auth.isLoggedIn) {
            if (auth.userInfo && allowedRoles?.includes(auth.userInfo?.role)) {
                return <Outlet />;
            } else {
                return !isServer ?<Navigate to={pageRoutes.DASHBOARD_USER} />:null;
            }
        } else {
            return !isServer ?<Navigate to={pageRoutes.LOGIN} />:null;
        }
    } else {
        if (auth.isLoggedIn) {
            return !isServer ?<Navigate to={pageRoutes.DASHBOARD_USER} />:null;
        } else {
            return !isServer ?<Navigate to={pageRoutes.LOGIN} />:null;
        }
    }
};

export default RequireAuth;
